var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('td',[_c('checkbox-input',{attrs:{"name":"address_ids[]","value":_vm.address.id},model:{value:(_vm.isSelected),callback:function ($$v) {_vm.isSelected=$$v},expression:"isSelected"}})],1),_vm._v(" "),_c('td',[_vm._v("\n        "+_vm._s(_vm.address.full_address_with_apartment_number)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }